import { Auth } from 'aws-amplify';
import _ from 'lodash';

const getAccessToken = async () => {
  const data = await Auth.currentSession();
  const token = data.getAccessToken().getJwtToken();
  return token;
};

export default getAccessToken;
